<script>
import loader from "@/components/Loader.vue";

export default {
  name: "ButtonWithLoading",
  components: {
    loader,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
  },
  emits: ["onClick"],
};
</script>

<template>
  <button
    class="custom-button button"
    :class="{ button__loading: isLoading }"
    :type="type"
    :disabled="isLoading"
    @click="$emit('onClick')"
  >
    <span class="text-btn" v-if="!isLoading">{{ title }}</span>
    <!-- <loader v-else :is-loading="true" /> -->

    <svg v-show="isLoading" class="svg_icon_loader">
      <use class="rotate-svg" xlink:href="@/assets/img/Loader.svg#loader"></use>
    </svg>
  </button>
</template>

<style scoped lang="scss">
.text-btn {
  font-size: 18px;
}

.svg_icon_loader {
  width: 30px;
  height: 30px;
  fill: #f8fafc;
}

.rotate-svg {
  animation: rotate 4s linear infinite;
  transform-origin: center;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
